import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { completeMailVerifiction } from '../../services/memberService';
import ActionNotification from '../../components/ActionNotification';

const EmailVerified = () => {
    const location = useLocation();
    const [isVerified, setIsVerified] = useState<boolean>(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        let userId = urlParams.get("userId");
        if (userId)
            completeStep(userId);
    }, [])

    const completeStep = async (userId: string) => {
        try {
            await completeMailVerifiction(userId);
        }
        catch (error) {
            setIsVerified(false);
        }
    };

    return (
        <>
            <ActionNotification
                title={`מייל אומת בהצלחה`}
                description={"text text text text"}
                showButton={true}
                buttonText={"המשך"}
                isError={!isVerified}
            />
        </>
    )
}

export default EmailVerified;